import useChatStore from "@/store/chatStore";
import { unreadLabel } from "@/utils/chat";
import { cn } from "@/lib/utils";

/** Telegram-style unread counter pill for the «واریز و برداشت» menu entries. */
export default function UnreadBadge({ count, className }) {
  const total = useChatStore((s) => s.unreadTotal);
  const label = unreadLabel(count ?? total);
  if (!label) return null;
  return (
    <span
      className={cn(
        "inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-[var(--tg-success)] px-1.5 text-[11px] font-bold leading-5 text-white shadow-sm",
        className
      )}
      aria-label={`${label} پیام خوانده‌نشده`}
    >
      {label}
    </span>
  );
}
